import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import {
  DialogWrapper,
  ModalContainer,
  ModalContent,
  ModalLabel,
  ModalRow,
  ModalSubtitle,
  ModalTitle,
  ModalValue,
} from './styles';
import { LieferanspruchModalProps } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import {
  formatNumber,
  mapLocaleAccordingToNzRules,
} from '../../../../helpers/localeFormatter';

const LieferanspruchModal: React.FC<LieferanspruchModalProps> = ({
  countryIsoCode,
  isOpen,
  onClose,
  data,
}) => {
  const { t } = useI18n();
  const mappedCountry = mapLocaleAccordingToNzRules(countryIsoCode);

  return (
    <DialogWrapper open={isOpen} onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', top: 16, right: 16 }}
        >
          <CloseIcon />
        </IconButton>
        <ModalTitle>
          {t(TranslationKeys.lieferanspruch_modal_title)} {data.year}
        </ModalTitle>
        <ModalContent>
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.lieferanspruch_modal_total_entitlement)}
            </ModalLabel>
            <ModalValue>
              {formatNumber(data.deliveryEntitlementTotal, mappedCountry)} T
            </ModalValue>
          </ModalRow>
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.lieferanspruch_modal_contracted_amount)}
            </ModalLabel>
            <ModalValue>
              {formatNumber(data.contractedAmount, mappedCountry)} T
            </ModalValue>
          </ModalRow>
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.lieferanspruch_modal_available_amount)}
            </ModalLabel>
            <ModalValue>
              {formatNumber(data.availableAmount, mappedCountry)} T
            </ModalValue>
          </ModalRow>
          <ModalSubtitle>
            {t(TranslationKeys.lieferanspruch_modal_subtitle_entitlement_info)}
          </ModalSubtitle>
          <p>
            {t(
              TranslationKeys.lieferanspruch_modal_text_entitlement_info_part1
            )}
          </p>
          <p>
            {t(
              TranslationKeys.lieferanspruch_modal_text_entitlement_info_part2
            )}
          </p>
          <ModalSubtitle>
            {t(TranslationKeys.lieferanspruch_modal_subtitle_factors)}
          </ModalSubtitle>
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.lieferanspruch_modal_factor_nz_holding)}
              {data.year}
            </ModalLabel>
            <ModalValue>
              {formatNumber(data.factorNzHolding, mappedCountry)}
            </ModalValue>
          </ModalRow>
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.lieferanspruch_modal_factor_union)}
              {data.year}
            </ModalLabel>
            <ModalValue>
              {formatNumber(data.factorUnion, mappedCountry)}
            </ModalValue>
          </ModalRow>
        </ModalContent>
      </ModalContainer>
    </DialogWrapper>
  );
};

export default LieferanspruchModal;
